import React,{useState} from 'react'
import {TextField, Button, Box, Typography, InputAdornment, FormControlLabel, Checkbox} from '@material-ui/core';
import { makeStyles, useTheme} from '@material-ui/core/styles';
import { Alert} from '@material-ui/lab';
import * as firebase from 'firebase';
import ReactGA from 'react-ga';
import dayjs from 'dayjs'
import { useForm } from "react-hook-form";

const useStyles = makeStyles((theme)=>({
    input:{
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      width: '100%'
    },
    button:{
        color:'white',
        fontFamily: 'ShameimaruSans',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        width: '100%'
    },
    buttonSecondary:{
        color: theme.palette.text.secondary,
       
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
     
    },
    box:{
        display:'flex',
        justifyContent:'center'
    },
    successContainer:{
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent:'center'
    },
  }));



export default function OtherFields(props) {
const [favorite, setFavorite] = useState()
const [hasAnswered, setHasAnswered] = useState(false)
const [email, setEmail] = useState('')
const classes = useStyles()
let db = firebase.firestore()
let analytics= firebase.analytics()
const theme = useTheme()
const currentTime = new Date()
let hours= currentTime.getHours()
let mins= currentTime.getMinutes()
let time=''+hours+mins
let inTime= 1700<=parseInt(time)&&parseInt(time)<=2100?true:false
const [checked, setChecked] = useState(false)
const [error, setError] = useState()







const handleButtonClick=()=> {
  if(props.answer==="zeitraum"||props.answer==="other"){
    analytics.logEvent('feedback_second_step_submit', {answer: props.answerMap[props.answer]})
      // ReactGA.event({category:'feedback',action:`${props.answer}-submit`})
      db.collection('answers').add({
          type: props.answer,
          answer: favorite?favorite:'N/A',
          email: email,
          time: new Date()
        }).then(()=>{
          setHasAnswered(true)
          props.setAnswer(1)
        })
      }
  

  if(checked){
    // if(email!==''){
    //     analytics.logEvent('feedback_second_step_email', {answer: props.answerMap[props.answer]})
    //     // ReactGA.event({category:'feedback',action:`${props.answer}-email`})
    // }
    if(favorite||email){
      analytics.logEvent('feedback_second_step_submit', {answer: props.answerMap[props.answer]})
      // ReactGA.event({category:'feedback',action:`${props.answer}-submit`})
      const timeToSend = dayjs(currentTime).subtract(props.answer==='zeit'?14:props.answer==='preis'?1:'/', "day").toDate()
      db.collection('answers').add({
          type: props.answer,
          answer: favorite?favorite:'N/A',
          email: email,
          time: new Date(),
          timeToSend: timeToSend
        }).then(()=>{
          setHasAnswered(true)
          props.setAnswer(1)
        })
      }
    }else{
      setError(true)
      
    }
    
    }

    const handleBack= ()=>{
        props.setStation()
        props.changePage(1)
    }
    
    const handleCheck = ()=>{
      setError()
      setChecked(!checked)
    }



    return (
        <React.Fragment>
        {hasAnswered?
            <Box className={classes.successContainer}>
                <Alert variant='filled' severity='success'  align='center' >
                Vielen Dank für dein Feedback. Wir arbeiten stetig daran, unser Angebot zu verbessern.
                </Alert>
                <Button onClick={()=>handleBack()} variant='text' className={classes.buttonSecondary}>Zurück</Button>
            </Box>:
        <form onSubmit={handleButtonClick}>
        {props.answer=='zeitraum'?
        <React.Fragment>
        <TextField
        className={classes.input}
          onChange={(event)=>setFavorite(event.target.value)}
          label="Wie lange würdest du gerne reservieren?"
          helperText="Hilf uns mit deiner Angabe, damit wir den Service weiter verbessern können."
          InputProps={{
            endAdornment: <InputAdornment position="end">Tag/e</InputAdornment>,
            inputProps: { 
              min:1,  
              max: 7
        }
          }}
          color='secondary'
          type='number'
          required
          fullWidth
          variant='outlined'
        />
        {/* <TextField
          onChange={(event)=>setEmail(event.target.value)}
          label="Email"
          color='secondary'
            type='email'
          fullWidth
          variant='outlined'
          helperText='Optional:Wir optimieren meintankpreis.de ständig und halten dich gerne über Updates auf dem Laufenden.'
        />
         <FormControlLabel
         style={{paddingTop:theme.spacing(2)}}
         name='terms'
           control={<Checkbox onError={!checked} checked={checked} onChange={handleCheck} />}
           label={<Typography  variant='caption' color={'textSecondary'} >Ich habe die <a style={{color: theme.palette.text.secondary}} target="_blank" href='https://www.whataventure.com/data-protection-policy'>
            Datenschutzerklärung</a> gelesen und akzeptiere sie.</Typography>}
         />
         
            {error?
            <Box style={{paddingLeft:theme.spacing(4)}}>
          <Typography  variant='caption' color='error' align='center'  >
          Du musst den Bedingungen zustimmen, bevor du fortfahren kannst.
          </Typography>
          </Box>:null
          } */}
        </React.Fragment>
        :props.answer=='zeit'?
        <React.Fragment>
        <Typography variant='body1' color='textPrimary' align='center' style={{paddingBottom:theme.spacing(2),paddingTop:theme.spacing(2)}}>
        Wir erinnern dich gerne in 7 Tagen, so dass du dann frühzeitig deinen Tankpreis reservieren und sparen kannst.
        </Typography>
        {/* <TextField
        className={classes.input}
          onChange={(event)=>setFavorite(event.target.value)}
          label="Wann möchtest Du erinnert werden?"
          color='secondary'
          type='number'
          InputProps={{
            endAdornment: <InputAdornment position="end">Tag/e</InputAdornment>,
            inputProps: { 
            min:1,  
            max: 7
        }
          }}
          
          required
          fullWidth
          variant='outlined'
        /> */}
        <TextField
          onChange={(event)=>setEmail(event.target.value)}
          label="Email"
          required={true}
          color='secondary'
            type='email'
          fullWidth
          variant='outlined'
        />
        <FormControlLabel
         
          name='terms'
            control={<Checkbox onError={!checked} checked={checked} onChange={handleCheck} />}
            label={<Typography  variant='caption' color={'textSecondary'} >Ich habe die <a style={{color: theme.palette.text.secondary}} target="_blank" href='https://www.whataventure.com/data-protection-policy'>
             Datenschutzerklärung</a> gelesen und akzeptiere sie.</Typography>}
          />
          
          {error?
          <Box style={{paddingLeft:theme.spacing(4)}}>
        <Typography  variant='caption' color='error' align='center'  >
        Du musst den Bedingungen zustimmen, bevor du fortfahren kannst.
        </Typography>
        </Box>:null
        }
        </React.Fragment>
        :props.answer=='preis'?
        <React.Fragment>
        <Typography variant='body1' color='textPrimary' align='center' style={{paddingBottom:theme.spacing(2),paddingTop:theme.spacing(2)}}>
        {inTime?'Herzlichen Glückwunsch, die Tankpreise sind derzeit (17:00  bis 21:00 Uhr) am günstigsten. Sichere Dir jetzt schnell deinen Tankpreis und spare.':
        'Die Tankpreise sind von 17:00 Uhr bis 21:00 Uhr am günstigsten.'}
        </Typography>
        <TextField
          onChange={(event)=>setEmail(event.target.value)}
          label="Email"
          required={true}
          color='secondary'
            type='email'
          fullWidth
          variant='outlined'
          helperText='Wir erinnern dich gern morgen, sodass du frühzeitig deinen Tankpreis reservieren kannst.'
        />
        <FormControlLabel
          style={{paddingTop:theme.spacing(2)}}
          name='terms'
            control={<Checkbox onError={!checked} checked={checked}  onChange={handleCheck}/>}
            label={<Typography  variant='caption' color={'textSecondary'} >Ich habe die <a style={{color: theme.palette.text.secondary}} target="_blank" href='https://www.whataventure.com/data-protection-policy'>
             Datenschutzerklärung</a> gelesen und akzeptiere sie.</Typography>}
          />
          
          {error?
          <Box style={{paddingLeft:theme.spacing(4)}}>
        <Typography  variant='caption' color='error' align='center'  >
        Du musst den Bedingungen zustimmen, bevor du fortfahren kannst.
        </Typography>
        </Box>:null
        }
        </React.Fragment>:
        props.answer=='other'?
        <React.Fragment>
        <TextField
        className={classes.input}
          onChange={(event)=>setFavorite(event.target.value)}
          label="Warum willst du meinTankpreis aktuell nicht nutzen?"
          color='secondary'
          multiline={true}
          rows={2}
          rowsMax={5}
          required
          fullWidth
          variant='outlined'
          helperText="Hilf uns mit deiner Angabe, damit wir den Service weiter verbessern können."
        />
        {/* <TextField
          onChange={(event)=>setEmail(event.target.value)}
          label="Email"
          color='secondary'
            type='email'
          fullWidth
          variant='outlined'
          helperText='Optional: Wir optimieren meintankpreis.de ständig und halten dich gerne über Updates auf dem Laufenden'
        />
        <FormControlLabel
          style={{paddingTop:theme.spacing(2)}}
          name='terms'
            control={<Checkbox onError={!checked} checked={checked}  onChange={handleCheck} />}
            label={<Typography  variant='caption' color={'textSecondary'} >Ich habe die <a style={{color: theme.palette.text.secondary}} target="_blank" href='https://www.whataventure.com/data-protection-policy'>
             Datenschutzerklärung</a> gelesen und akzeptiere sie.</Typography>}
          />
          
          {error?
          <Box style={{paddingLeft:theme.spacing(4)}}>
        <Typography  variant='caption' color='error' align='center'  >
        Du musst den Bedingungen zustimmen, bevor du fortfahren kannst.
        </Typography>
        </Box>:null
        } */}
        </React.Fragment>:null
        }
        <Button className={classes.button} type='submit' fullWidth color='secondary' variant='contained'>
                Senden</Button>
        <Box className={classes.box}>
        <Button onClick={()=>handleBack()} variant='text' className={classes.buttonSecondary}>Zurück</Button>
        </Box>
        </form>}
        </React.Fragment>

    )
}
